const EXTERNAL_API = 'https://api-myportfolio.rankia.com'

function apiBase () {
  const host = window.location.hostname
  return (host === 'localhost' || host === '127.0.0.1') ? '/api' : EXTERNAL_API
}

class FundReturnsSummary extends HTMLElement {
  connectedCallback () {
    const isin = this.getAttribute('isin')
    if (!isin) return

    this.fetchAndRender(isin)
  }

  async fetchAndRender (isin) {
    try {
      const response = await fetch(`${apiBase()}/funds/product/${encodeURIComponent(isin)}/statistic`)
      if (!response.ok) return

      const data = await response.json()
      const stats = data?.stats
      if (!stats) return

      this.render(stats)
    } catch {
      // Silently fail - the component simply won't show data
    }
  }

  render (stats) {
    const locale = this.getAttribute('locale') || 'es'
    const items = []

    const avg3y = this.calculateAverage3y(stats)
    if (avg3y !== null) {
      items.push(this.buildItem('Rent. media últimos 3 años', avg3y, locale))
    }

    const ytd = stats.returnYtd
    if (ytd !== undefined && ytd !== null && !Number.isNaN(ytd)) {
      items.push(this.buildItem('Rentabilidad YTD', ytd, locale))
    }

    const validItems = items.filter(Boolean)
    if (validItems.length === 0) return

    const container = document.createElement('div')
    container.className = 'rnk-flex-from-l u-grid-gap-2'
    validItems.forEach(item => container.appendChild(item))
    this.appendChild(container)
  }

  calculateAverage3y (stats) {
    const years = [stats.returnLast1y, stats.returnLast2y, stats.returnLast3y]
    const valid = years.filter(v => v !== undefined && v !== null && !Number.isNaN(v))
    if (valid.length === 0) return null

    return valid.reduce((sum, v) => sum + v, 0) / valid.length
  }

  buildItem (label, value, locale) {
    if (!Number.isFinite(value)) return null

    const percentage = new Intl.NumberFormat(locale, {
      style: 'percent',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value)

    const cssClass = value < 0
      ? 'rnk-LiquidationValue_Evolution-negative'
      : 'rnk-LiquidationValue_Evolution-positive'

    const div = document.createElement('div')
    div.className = 'rnk-margin-top-medium'

    const bold = document.createElement('b')
    bold.textContent = `${label}: `

    const span = document.createElement('span')
    span.className = cssClass
    span.textContent = percentage

    bold.appendChild(span)
    div.appendChild(bold)

    return div
  }
}

export default FundReturnsSummary
